<div class="modal-header">
  <h4 class="modal-title">
    @if (tag) {
      Editar tag
    }
    @if (!tag) {
      Nuevo tag
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  @if (loading) {
    <div class="d-flex justify-content-center">
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  } @else {

    <form
      id="formTag"
      [formGroup]="formTag"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @for (key of utilService.objectKeys(dataForm); track key) {

            @if (dataForm[key].type === 'text') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

            @if (dataForm[key].type === 'select') {
              <div class="mb-4">
                <div class="mb-1">
                  {{ dataForm[key].label }}
                </div>

                @if (dataForm[key].imageSelect) {
                  <ng-select
                    [items]="dataForm[key].data!"
                    [bindLabel]="dataForm[key].labelSelect!"
                    [bindValue]="dataForm[key].idSelect!"
                    formControlName="{{ key }}"
                    [placeholder]="dataForm[key].placeholder ?? ''"
                    (ngModelChange)="dataForm[key].onChange ? dataForm[key].onChange!($event) : null">
                    <ng-template ng-label-tmp let-item="item">
                      <div class="d-flex align-items-center gap-2">
                        @if (item?.image?.urlFile) {
                          <img [src]="item.image.urlFile"
                               style="width: 1.8rem; height: 1.8rem; object-fit: cover; border-radius: 4px;">
                        }
                        <span>{{ item?.description }}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div class="d-flex align-items-center gap-2">
                        @if (item?.image?.urlFile) {
                          <img [src]="item.image.urlFile"
                               style="width: 2.2rem; height: 2.2rem; object-fit: cover; border-radius: 4px;">
                        }
                        <span>{{ item?.description }}</span>
                      </div>
                    </ng-template>
                  </ng-select>
                } @else {
                  <ng-select
                    [items]="dataForm[key].data!"
                    [bindLabel]="dataForm[key].labelSelect!"
                    [bindValue]="dataForm[key].idSelect!"
                    formControlName="{{ key }}"
                    [placeholder]="dataForm[key].placeholder ?? ''"
                    (ngModelChange)="dataForm[key].onChange ? dataForm[key].onChange!($event) : null">
                  </ng-select>
                }

                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="text-danger">
                    @if (f[key].errors!['required']) {
                      {{ dataForm[key].requiredMessage }}
                    }
                  </div>
                }
              </div>
            }

            @if (dataForm[key].type === 'switch') {
              <div class="col-12 mt-2 mb-4">
                <div class="row">
                  <div class="col-8">
                    {{ dataForm[key].label }}
                  </div>
                  <div class="col-4 text-end">
                    <p-inputSwitch formControlName="{{ key }}"></p-inputSwitch>
                  </div>
                </div>
              </div>
            }

            @if (dataForm[key].type === 'textarea') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <textarea
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }"></textarea>
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

          }

        </div>
      </div>
    </form>

  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formTag"
      class="btn btn-primary w-100">
      {{ tag ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
